module.exports = __webpack_public_path__ + "media/images/suppliers/biosb-9cc655ec3e07e53f4ac29120c9eb4da7.png";